// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1t-2";
export var blackBorderOnHover = "_1t-7";
export var cell = "_1t-6";
export var cellContainer = "_1t-3";
export var checked = "_1t-8";
export var disabled = "_1t-5";
export var featuredIconCellContainer = "_1t-9";
export var featuredIconTextContainer = "_1t-b";
export var featuredIconWrapper = "_1t-a";
export var noBorder = "_1t-c";
export var orangeSelectedRow = "_4q-3";
export var overflowableText = "_1t-0";
export var overflowableTextContainer = "_1t-1";
export var row = "_1n-0";
export var rowCheckboxCell = "_1t-4";
export var selectableTable = "_4q-2";